// extracted by mini-css-extract-plugin
export default {"root":"Header_root__oKVd1","tabList":"Header_tabList__3EPBp","tab":"Header_tab__2TZB5","on":"Header_on__2dcCH","allReviewsLink":"Header_allReviewsLink__22ZUZ"};